<template>
  <!--begin::App-->
  <div class="app-root" id="kt_app_root">
    <!--begin::Page-->
    <div class="app-page pb-10" id="kt_app_page">
      <div class="password-reset p-4">
        <div class="container h-100">
          <div class="d-flex flex-column flex-lg-row justify-content-lg-between bg-white br-40 h-100">
            <div class="col-12 col-lg-6 order-1 order-lg-0">
              <div class="d-flex flex-column justify-content-center h-100 p-10">
                <router-link class="logo" :to="'/'">
                  <img src="/images/layout/logo-pixel-principal.png" alt="Pixel Roads" class="logo mb-5" />
                </router-link>
                <h1 class="font3 font-size-xLarge fw-300 lh-1" v-html="$t('choose_new_password')"></h1>
                <form
                  class="default-form mt-5"
                  @submit.prevent="submit"
                >
                  <div class="form-group mb-3">
                    <label class="form-label font-size-regular font3">{{ $t('email') }}</label>
                    <input
                      type="email"
                      class="form-control form-control-sm"
                      :label="$t('email_address')"
                      :placeholder="$t('enter_your_email')"
                      v-model.trim="$v.form.email.$model"
                    />
                  </div>

                  <div class="form-group mb-3">
                    <label class="form-label font-size-regular font3">{{ $t('password') }}</label>
                    <input type="password" class="form-control form-control-sm" :placeholder="$t('enter_your_password')" v-model.trim="$v.form.password.$model" autocomplete="new-password" />
                  </div>
                  <div class="form-group mb-3">
                    <label class="form-label font-size-regular font3">{{ $t('confirm_password') }}</label>
                    <input type="password" class="form-control form-control-sm" :placeholder="$t('confirm_password')" v-model.trim="$v.form.password_confirmation.$model" autocomplete="new-password" />
                  </div>

                  <div class="mt-5">
                    <Button
                      class="btn-color5 btn-lg w-100"
                      :loading="loader"
                      :disabled="$v.$invalid"
                      @click="submit"
                    >
                      {{ $t('confirm_new_password') }}
                    </Button>
                  </div>
                </form>
              </div>
            </div>
            <div class="col-12 col-lg-6 order-0 order-lg-1 d-none d-lg-block position-relative text-end login-image">
              <div class="h-100">
                <div class="position-absolute w-100 d-flex justify-content-end">
                  <select v-model="$i18n.locale" id="language" class="form-select font-size-small border-0 w-auto" @change="handleLanguageChange">
                    <option value="pt_BR">PT</option>
                    <option value="en" selected>EN</option>
                    <option value="es">ES</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <TheFooter />
    </div>
    <!--end::Page-->
  </div>
  <!--end::App-->
</template>

<script>

import AuthService from '@/modules/auth/services/auth-service'
import NotificationService from '@/modules/notifications/services/notifications-service'
import UsersService from '@/modules/users/services/users-service'
import { required, email } from 'vuelidate/lib/validators'
import { mapState } from 'vuex'

import Button from '@/components/common/Button/Button'
import TheFooter from '@/components/footers/TheFooter2'

export default {
  components: {
    Button,
    TheFooter
  },
  data () {
    return {
      form: {
        email: '',
        password: '',
        password_confirmation: '',
        token: this.$route.params.token
      },
      loader: false
    }
  },
  metaInfo () {
    return {
      title: this.$t('confirm_new_password')
    }
  },
  validations () {
    return {
      form: {
        email: { required, email },
        password: { required },
        password_confirmation: { required },
        token: { required }
      }
    }
  },
  computed: {
    ...mapState('auth', {
      authenticated: state => state.authenticated
    })
  },
  created () {
    this.handleLanguage()
  },
  methods: {
    async handleLanguage () {
      const language = await UsersService.getCookie('user_language')
      if (language) {
        this.$i18n.locale = language
      } else {
        await UsersService.setCookie('user_language', 'pt_BR', 30)
        this.$i18n.locale = 'pt_BR'
      }
    },
    async handleLanguageChange () {
      await UsersService.setCookie('user_language', this.$i18n.locale, 30)
    },
    async submit () {
      this.loader = true
      try {
        await AuthService.sendResetPassword(this.form)
        const notification = {
          notification: {
            type: 'success',
            content: this.$t('password_updated_successfully')
          }
        }
        NotificationService.createGlobalSuccessNotification(notification)
        this.$router.push('/')
      } catch (error) {
        error.handleGlobally && error.handleGlobally()
      }
      this.loader = false
    }
  }
}
</script>

<style lang="scss" scoped>
  .logo {
    img {
      width: 150px;
    }
  }

  .app-page {
    flex-direction: column;
    overflow: hidden;
    background: #F8F9FA;
  }

  .app-root, .app-page {
    @media (min-height: 768px) {
      height: 100%;
    }
    @media (min-height: 1200px) {
      height: auto;
    }
  }

  .password-reset {
    background: #ECD263;
    height: 85%;
  }

  .login-image {
    border-radius: 0 0 40px 0;
    max-height: 100%;
    background: url('/images/v2/layout/image-login.jpg') no-repeat;
    background-size: cover;
  }
</style>
